import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BreakingTicker from './components/BreakingTicker';
import HeroSection from './components/HeroSection';
import EventStream from './components/EventStream';
import FollowUpZone from './components/FollowUpZone';
import SubscribeBanner from './components/SubscribeBanner';
import { gossipEvents } from '@/mocks/gossipEvents';
import type { GossipEvent } from '@/types/gossip';

export default function Home() {
  const events = gossipEvents as unknown as GossipEvent[];
  const featured = events[0];
  const followUpFeatured = events.find((event) => event.timeline.length >= 4) || events[0];
  const responseFeed = events
    .filter((event) => event.latestText)
    .slice(2, 7);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <BreakingTicker />
      <main className="w-full">
        <HeroSection event={featured} />
        <EventStream events={events} />
        <FollowUpZone featured={followUpFeatured} feed={responseFeed} />
        <SubscribeBanner />
      </main>
      <SiteFooter />
    </div>
  );
}